import React from 'react';
import Router from '@alltrails/shared/components/ReactRouter';
import { Route, Switch } from 'react-router-dom';

import usePathname from 'hooks/usePathname';
import Header from '../Header';
import TrailsTable from '../TrailsTable';
import AlertsTable from '../AlertsTable';
import Dashboard from '../Dashboard';
import * as styles from './styles/styles.module.scss';

const Portal = (): JSX.Element => {
  const fullpath = usePathname();

  return (
    <Router fullpath={fullpath}>
      <div className={styles.wrapper}>
        <Header fullpath={fullpath} />
        <Switch>
          <Route path="*/portal" exact>
            <TrailsTable />
          </Route>
          <Route path="*/portal/alerts" exact>
            <AlertsTable />
          </Route>
          <Route path="*/portal/dashboard" exact>
            <Dashboard />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

export default Portal;
